export default "assets/videos/joseph-shake-it.mp4";